/**
 * @description
 * Este arquivo define as rotas (paths) do frontend da aplicação (vulgo os diferentes caminhos da URL).
 *
 * As rotas descritas no arquivo `src/utils/axios.ts` são referentes aos endpoints do backend,
 * que serão utilizados para a integração do front-end ao back-end, via repositories.
 */

const ROOTS = {
  AUTH: '/auth',
  BACKOFFICE: '/backoffice',
};

export const paths = {
  root: '/',
  auth: {
    root: ROOTS.AUTH,
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    refresh: `${ROOTS.AUTH}/refresh`,
  },

  error: {
    notFound: '/404',
    forbidden: '/403',
    serverError: '/500',
  },

  backoffice: {
    root: ROOTS.BACKOFFICE,
    home: `${ROOTS.BACKOFFICE}/home`,

    // ADMIN
    admin: {
      root: `${ROOTS.BACKOFFICE}/admin`,
      list: `${ROOTS.BACKOFFICE}/admin`,
      new: `${ROOTS.BACKOFFICE}/admin/new`,
      edit: (id: string) => `${ROOTS.BACKOFFICE}/admin/${id}/edit`,
    },

    // SHOPPINGS
    shopping: {
      root: `${ROOTS.BACKOFFICE}/shoppings`,
      list: `${ROOTS.BACKOFFICE}/shoppings`,
      new: `${ROOTS.BACKOFFICE}/shoppings/new`,
      edit: (id: string) => `${ROOTS.BACKOFFICE}/shoppings/${id}/edit`,
    },

    // CLIENT ADMINS
    clientAdmins: {
      root: `${ROOTS.BACKOFFICE}/client-admins`,
      selectClient: `${ROOTS.BACKOFFICE}/client-admins`,
      list: (clientId: string) => `${ROOTS.BACKOFFICE}/client-admins/${clientId}`,
      new: (clientId: string) => `${ROOTS.BACKOFFICE}/client-admins/${clientId}/new`,
      edit: (clientId: string, adminId: string) => `${ROOTS.BACKOFFICE}/client-admins/${clientId}/${adminId}/edit`,
    },
  },
};
